import {
    getData,
    postData
  } from './api-base.service';  

export const getFileStorage = (fileStorageId) => {
    let data = {
        fileStorageId: fileStorageId
    };

    let result = getData('/FileStorage/GetFileStorage', data);
    return result;
}    

export const saveCourseScoreFile = (studentSpeedupCourseId, fileData) => {
    let data = {
        StudentSpeedupCourseId: studentSpeedupCourseId,
        FileId: fileData.fileId,
        SourceFileName: fileData.sourceFileName,
        UploadFileName: fileData.uploadFileName,
        FileStorageType : fileData.fileStorageType
    };
    
    let result = postData('/FileStorage/SaveCourseScoreFile', data);
    return result;
}

export const saveUploadFile = (fileData) => {
    let data = {
        FileId: fileData.fileId,
        SourceFileName: fileData.sourceFileName,
        UploadFileName: fileData.uploadFileName,
        FileStorageType : fileData.fileStorageType
    };
    
    return postData('/FileStorage/SaveUploadFile', data);
}

export const getBlobStorageConfig = () => {
    let result = getData('/FileStorage/GetBlobStorageConfig');
    return result;
}

export const getSharedAccessSignature = (isViewOnly) => {
    if (typeof isViewOnly == "undefined"){
        isViewOnly = false;
    }
    let data={isViewOnly: isViewOnly};
    let result = getData('/FileStorage/GetSharedAccessSignature', data);
    return result;
}


// WEBPACK FOOTER //
// ./src/service/blobStorage.service.js